import { Component, inject, Signal } from '@angular/core';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    standalone: true,
    selector: 'app-toggle-edit-mode',
    templateUrl: './toggle-edit-mode.component.html',
    styleUrls: ['./toggle-edit-mode.component.scss'],
    imports: [
      MatButtonModule,
      MatIcon
    ]
})

export class ToggleEditModeComponent {
  private stateService = inject(WebsiteStateService);
  public isEditMode: Signal<boolean> = this.stateService.isEditMode;

  public toggleEditMode(): void {
    this.stateService.toggleMode();
  }
}